module.exports = __webpack_public_path__ + "fonts/Trade-Gothic-LT.eot";


//////////////////
// WEBPACK FOOTER
// ./Common/fonts/Trade-Gothic-LT.eot
// module id = 5
// module chunks = 0 1 2 3 4 5 6 7